import React from 'react';
// --- 1. Import ConfigProvider ---
import { Modal, Button, ConfigProvider } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

// --- 2. Define your brand's theme colors and styles ---
const modalTheme = {
  token: {
    // This is your brand's main font
    fontFamily: "'Montserrat', sans-serif",
    
    // This is your brand's dark color for the button
    colorPrimary: '#383837',
    
    // This removes the rounded corners from all components inside this provider
    borderRadius: 0,
  },
};

const SuccessModal = ({ open, onClose, message }) => {
  return (
    // --- 3. Wrap the Modal in the ConfigProvider ---
    <ConfigProvider theme={modalTheme}>
      <Modal
        open={open}
        onCancel={onClose}
        footer={[
          // The Button will now automatically inherit the theme styles
          <Button key="ok" type="primary" onClick={onClose}>
            OK
          </Button>,
        ]}
        centered
        closable={false}
        destroyOnClose
      >
        <div style={{
          textAlign: 'center',
          padding: '2rem 1rem 1rem 1rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1rem'
        }}>
          <CheckCircleFilled style={{ fontSize: '48px', color: '#52c41a' }} />
          
          <p style={{
            fontSize: '1.2rem',
            fontWeight: '500',
            color: '#383837', // Use your brand's dark text color
            margin: 0
          }}>
            {message}
          </p>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default SuccessModal;